import { notification } from "antd";

let handlingExpiry = false;

const PUBLIC_PATHS = new Set(["/", "/signup", "/forgot", "/resetpasswordwithtoken"]);

function isPublicPath(pathname) {
  if (PUBLIC_PATHS.has(pathname)) return true;
  return pathname.startsWith("/resetpasswordwithtoken");
}

/** Clear auth and send user to login - once per burst of 401s, no reload loop on "/". */
export function handleSessionExpired(message) {
  if (handlingExpiry) return;
  handlingExpiry = true;

  const pathname = window.location.pathname;
  const hadSession =
    Boolean(localStorage.getItem("sessionId")) ||
    Boolean(localStorage.getItem("merchantId"));

  localStorage.removeItem("sessionId");
  localStorage.removeItem("merchantId");

  notification.info({
    message:
      message || "Your session has expired. Please login again.",
    key: "session-expired",
  });

  if (!isPublicPath(pathname)) {
    window.location.replace("/");
    return;
  }

  // Already on login - do not reload; clearing storage stops background fetches.
  if (!hadSession) {
    handlingExpiry = false;
  }
}
